import React, { useContext } from "react";
import Report from "./Report";
import ActionsContext from "common/ActionsContext";
import ProtocolsThroughputHelpModal from "./Help";
import { Header } from "common/Header";

const ContextMenu = () => {
  const actions = useContext(ActionsContext);
  return (
    <ul className="context-menu header-dropdown m-r--5">
      <a
        data-loading-effect="pulse"
        data-toggle="cardloading"
        title="Help"
        onClick={() => actions.send("open-help")}
      >
        <i className="material-icons">help_outline</i>
      </a>
      <a
        onClick={() => actions.send("do-load")}
        data-toggle="cardloading"
        data-loading-effect="pulse"
        title="Refresh"
      >
        <i className="material-icons">refresh</i>
      </a>
    </ul>
  );
};

const ProtocolsThroughput = ({directions = undefined }) => (
  <div id="viewThroughputProtocols" className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div className="card">
      <Header
        title="Throughput by protocols"
        contextMenu={<ContextMenu />}
      />
      <div className="body flex-panel-column">
        <Report />
      </div>
      <ProtocolsThroughputHelpModal directions={directions} />
    </div>
  </div>
);

export default ProtocolsThroughput;
